import 'css-chunksrc/client/scenes/chatbot/chatInputArea/styles.scss';export default {
  "chatInputArea": "_chatInputArea_ea7ey_1",
  "pill": "_pill_ea7ey_5",
  "input": "_input_ea7ey_15",
  "actions": "_actions_ea7ey_31",
  "submitButton": "_submitButton_ea7ey_38"
};